import type { RideType } from 'models/shared';

// The subset of ride types the `[vehiclesForSale]` route serves.
// `All` is a synthetic value used by `/vehicles-for-sale` to render every
// vehicle ride type in one page.
export type VehicleForSaleRideType =
  | 'Dirt Bikes'
  | 'ATV'
  | 'UTV'
  | 'Street'
  | 'Snow'
  | 'PWC'
  | 'E-Moto'
  | 'All';

// Ride types included when `rideType === 'All'`. Used both for typesense
// `category:[...]` filters and for `useBikes` make/model lookups.
export const ALL_VEHICLE_RIDE_TYPES: RideType[] = [
  'Dirt Bikes',
  'ATV',
  'UTV',
  'Street',
  'Snow',
  'PWC',
  'E-Moto',
];

// Display label per vehicle type, used in SEO copy and headings.
const RIDE_TYPE_LABELS: Record<VehicleForSaleRideType, string> = {
  'Dirt Bikes': 'Dirt Bikes',
  ATV: 'ATVs',
  UTV: 'UTVs',
  Street: 'Street Bikes',
  Snow: 'Snowmobiles',
  PWC: 'PWCs',
  'E-Moto': 'E-Moto Bikes',
  All: 'Vehicles',
};

export const getVehicleLabel = (rideType: VehicleForSaleRideType): string =>
  RIDE_TYPE_LABELS[rideType];

// `useBikes` expects a `RideType`; `VehicleForSaleRideType` (minus `All`) is a
// subset of it. Callers handling `All` should pass `ALL_VEHICLE_RIDE_TYPES`
// directly instead of going through this helper.
export const toRideType = (rideType: VehicleForSaleRideType): RideType | '' =>
  rideType === 'All' ? '' : rideType;
